import React from "react";
import { useNavigate } from "react-router-dom";

const ReturnGiftBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-8 mt-4" onClick={() => navigate("/return-gift")} style={{ cursor: "pointer" }}>
      <div className="w-full py-2.5 bg-gradient-to-r from-pink-500 via-rose-500 to-pink-400 text-white text-center shadow-xl rounded-xl relative overflow-hidden border border-pink-300/20">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgb(255,255,255)_0%,transparent_10%)] opacity-10"></div>
        <div className="absolute -inset-1 bg-gradient-to-r from-transparent via-pink-100/20 to-transparent opacity-30 animate-[shine_4s_ease-in-out_infinite] -skew-x-12"></div>

        <div className="flex items-center justify-center space-x-3 relative z-10 px-4">
          <div className="relative flex items-center justify-center bg-white/10 p-1.5 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M12 8v13m0-13V6a4 4 0 00-4-4H6m6 6a4 4 0 014-4h2M6 8h12a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2z"
              />
            </svg>
            <div className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-yellow-300 rounded-full shadow-sm shadow-yellow-300/50 animate-pulse"></div>
          </div>

          <div className="inline-flex items-center">
            <span className="font-semibold text-sm md:text-base tracking-wide">
              <span className="uppercase tracking-wider">Return Gifts</span>
              <span className="mx-1 text-pink-200">•</span>
              <span>Perfect for every occasion — Shop Now!</span>
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1.5 text-yellow-300" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnGiftBanner;
